import type { InitOptions } from 'i18next';

export const FALLBACK_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'de', 'fr', 'es', 'it', 'pt'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_NAMES: Record<AppLanguage, string> = {
    en: 'English',
    de: 'Deutsch',
    fr: 'Français',
    es: 'Español',
    it: 'Italiano',
    pt: 'Português'
};

export function isSupportedLanguage(value: string): value is AppLanguage {
    return (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

export function normalizeLanguage(value: string | null | undefined): AppLanguage {
    if (!value) return FALLBACK_LANGUAGE;
    const candidate = value.trim().toLowerCase().slice(0, 2);
    return isSupportedLanguage(candidate) ? candidate : FALLBACK_LANGUAGE;
}

export const baseI18nConfig: InitOptions = {
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: { escapeValue: false },
    returnNull: false,
    react: { useSuspense: false }
};
